import { useQuery } from '@tanstack/react-query';
import { useOrganizationStore } from '@/core/stores/organization.store';
import { checklistsService } from '../api/checklists.service';
import { CHECKLIST_KEYS } from './queryKeys';

/** Loads all checklists (with items) for a task. */
export function useTaskChecklists(taskId: string | null) {
  const activeOrganizationId = useOrganizationStore((s) => s.activeOrganizationId)!;

  return useQuery({
    queryKey: CHECKLIST_KEYS.byTask(activeOrganizationId, taskId ?? ''),
    queryFn: async ({ signal }) => {
      const { data } = await checklistsService.getByTask(taskId!, signal);
      return data;
    },
    staleTime: 60_000,
    enabled: !!activeOrganizationId && !!taskId,
  });
}
